var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 32.5V16.2L17.3 21.4L14.5 18.5L24.5 8.5L34.5 18.5L31.7 21.4L26.5 16.2V32.5H22.5ZM12.5 40.5C11.4 40.5 10.4587 40.1087 9.676 39.326C8.89333 38.5433 8.50133 37.6013 8.5 36.5V30.5H12.5V36.5H36.5V30.5H40.5V36.5C40.5 37.6 40.1087 38.542 39.326 39.326C38.5433 40.11 37.6013 40.5013 36.5 40.5H12.5Z",
    fill: "#0A3B70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.082bce09add02e24c6b596ce270bc76a.svg";
export { ForwardRef as ReactComponent };